// extracted by mini-css-extract-plugin
module.exports = {"menuSeparator":"style_menuSeparator__2Qypx"};